var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    Object.keys(_vm.quizResults).length > 0 &&
      Object.keys(_vm.quizResults.counts).length > 0
  )?_c('BarChart',{staticClass:"chart-container",attrs:{"chartdata":_vm.chartDataQuizResults(),"options":_vm.quizResultOptions}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }